module.exports = __webpack_public_path__ + "static/media/1POLICY30.3c941e03.jpg";